import { render, staticRenderFns } from "./roomForm.vue?vue&type=template&id=0986ade7&scoped=true&"
import script from "./roomForm.vue?vue&type=script&lang=js&"
export * from "./roomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986ade7",
  null
  
)

export default component.exports